import { ActionCreators, ICurrency } from 'exchange-common'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { ws } from '../functions/ws'
import { IState } from '../models/state'

export const ServicesMain = () => {

	const logos: any = {
		LINK: require('../images/LINK.svg'),
		BRL: require('../images/BRL.svg'),
		USDC: require('../images/USDC.svg'),
		BTC: require('../images/bitcoin.svg'),
		LTC: require('../images/litecoin.svg'),
		ETH: require('../images/ethereum.svg'),
		EBIT: require('../images/ebit.svg'),
		DOGE: require('../images/dogecoin.svg'),
	}
	
	const currencies = useSelector((state: IState) => state.currencies)
	const currenciesLoaded = Boolean(Object.keys(currencies.list).length)
	useEffect(() => {
		if (!currenciesLoaded) {
			ws.send(ActionCreators.Subscribe.currencies())
		}
	}, [])

	if (!currenciesLoaded) {
		return <div />
	}
	const toggleDeposits = (id: number) => {
		if (confirm('Are you sure?')) {
			const currency = currencies.list[id]
			ws.send(ActionCreators.Currency.update({
				id,
				canDeposit: !currency.canDeposit,
			} as ICurrency))
		}
	}

	const toggleWithdrawals = (id: number) => {
		if (confirm('Are you sure?')) {
			const currency = currencies.list[id]
			ws.send(ActionCreators.Currency.update({
				id,
				canWithdraw: !currency.canWithdraw,
			} as ICurrency))
		}
	}

	return (
		<div className='walletsMain'>
			<span className='pageTitle'>Services</span>
			<span className='pageBoxTitle'>Blockchains</span>
			<div>
				<table className='walletsTableMain'>
					<thead>
						<tr className='walletsTableHeaderRow'>
							<td className='walletsTableHeaderRowItem coinColumn'>Coin</td>
							<td className='walletsTableHeaderRowItem coinNameColumn'>Name</td>
							<td className='walletsTableHeaderRowItem'>Deposit Status</td>
							<td className='walletsTableHeaderRowItem'>Deposit Action</td>
							<td className='walletsTableHeaderRowItem'>Withdraw Status</td>
							<td className='walletsTableHeaderRowItem'>Withdraw Action</td>
						</tr>
					</thead>
					<tbody>
						{Object.values(currencies.list).filter(f => f.fiat === false).map((c: ICurrency) => 
							<tr className='walletsTableBodyRow' key={c.id}>
								<td className='walletsTableBodyRowItem'><img src={logos[c.tag]} className='walletsLogo' alt={c.tag} /> {c.tag}</td>
								<td className='walletsTableBodyRowItem'>{c.name}</td>
								<td className='walletsTableBodyRowItem'><span className={c.canDeposit ? 'green' : 'red'}><b>{c.canDeposit ? 'Enabled' : 'Disabled'}</b></span></td>
								<td className='walletsTableBodyRowItem'><button className='walletsTableButton' onClick={() => toggleDeposits(c.id)}>{c.canDeposit ? 'Turn Off' : 'Turn On'}</button></td>
								<td className='walletsTableBodyRowItem'><span className={c.canWithdraw ? 'green' : 'red'}><b>{c.canWithdraw ? 'Enabled' : 'Disabled'}</b></span></td>
								<td className='walletsTableBodyRowItem'><button className='walletsTableButton' onClick={() => toggleWithdrawals(c.id)}>{c.canWithdraw ? 'Turn Off' : 'Turn On'}</button></td>
							</tr>
						)}
					</tbody>
				</table>
			</div>
		</div >
	)
}



// WEBPACK FOOTER //
// ./src/components/servicesMain.tsx